module.exports = __webpack_public_path__ + "static/media/arrow-down-grey.4d4a6a99.svg";